/**
* Created by kongwm.kong on 2017/7/25.
*/
<template>
    <div class="manager-detail-wrap form-page-wrap">
        <div class="bread-wrap">
            <div class="layout_n">
                <router-link to="/fund">基金经理管理</router-link> > <span>{{managerType==1 ? '已加入基金经理' : managerType==2 ? '待加入基金经理': '新增基金经理'}}</span>
            </div>
        </div>
        <div class="layout_n margin">
            <div class="message_content">
                <div class="process_wrap">
                    <div class="liner">
                        <div :class="{ 'line':true, 'line2': step2, 'line3': step3}"></div>
                    </div>
                    <!--步骤开始-->
                    <div class="step_wrap clearfix" >
                        <div :class="{ 'step': true, 'now': step1 , 'prev': step2||step3}">
                            <div class="step_line">
                                <div :class="{'first': step2||step3 , 'line': true}"></div>
                                <div class="radius_wrap">
                                    <div class="radius">1</div>
                                </div>
                            </div>
                            <div class="text">编辑基金经理信息</div>
                        </div>
                        <div :class="{ 'step': true, 'now': step2 , 'prev': step3}">
                            <div class="step_line">
                                <div class="line"></div>
                                <div class="radius_wrap">
                                    <div class="radius">2</div>
                                </div>
                            </div>
                            <div class="text">信息审核中</div>
                        </div>
                        <div :class="{ 'step': true, 'now': step3 }">
                            <div class="step_line">
                                <div class="line"></div>
                                <div class="radius_wrap">
                                    <div class="radius">3</div>
                                </div>
                            </div>
                            <div class="text">信息发布</div>
                        </div>
                    </div>
                </div>
                <div class="item-wrap">
                    <form @submit.prevent="goSubmit">
                        <!--基本信息-->
                        <div class="item">
                            <div class="title"><div class="sub-title">基本信息</div></div>
                            <div class="baseinfo-wrap">
                                <!--一系列表单-->
                                <ul class="clearfix">
                                    <li>
                                        <div class="input_wrap">
                                            <label class=" label required">姓名</label>
                                            <input type="text" maxlength="10" :readonly="step2" name="managerName" v-model="baseInfo.name" v-validate="'required'" placeholder="">
                                        </div>
                                        <div class="err">
                                            <span v-show="!step2&&errors.has('managerName')">{{errors.first('managerName')}}</span>
                                        </div>
                                    </li>
                                    <li>
                                        <div class="input_wrap">
                                            <label class=" label required">性别</label>
                                            <div class="select-ul-wrap">
                                                <vue-select  :name="'gender'" :readonly="step2" @closed="closedGender" @selected="getGender" v-model="msg.gender" :id="baseInfo.gender" :selectKey="'title'" :placeholder="'选择性别'"  :selectList="list.sexList"></vue-select>
                                            </div>
                                        </div>
                                        <div class="err">
                                            <span v-show="!step2 && msg.genderFlag">请选择性别</span>
                                        </div>
                                    </li>
                                    <li>
                                        <div class="input_wrap">
                                            <label class=" label">出生日期</label>
                                            <div class="date-wrap" v-if="!step2">
                                                <date-picker class="date-time" language="zh"  :format="'yyyy-MM-dd'" name="birthYear" v-model="baseInfo.birthYear1" :input-class="'input'"></date-picker>
                                            </div>
                                            <input v-else v-model="msg.birthYear2" :readonly="step2">
                                        </div>
                                        <div class="err">
                                            <!--<span v-show="msg.birthYearFlag">请选择出生日期</span>-->
                                        </div>
                                    </li>
                                    <li>
                                        <div class="input_wrap">
                                            <label class="label">电话</label>
                                            <input type="text" name="mobile" :readonly="step2" v-model="baseInfo.phone"  v-validate="'mobile'" placeholder="">
                                        </div>
                                        <div class="err">
                                           <span v-show="!step2&&errors.has('mobile')">{{errors.first('mobile')}}</span>
                                        </div>
                                    </li>
                                    <li>
                                        <div class="input_wrap">
                                            <label class=" label">邮箱</label>
                                            <input type="text" name="email" :readonly="step2" v-model="baseInfo.email"  v-validate="'email'" placeholder="">
                                        </div>
                                        <div class="err">
                                             <span v-show="!step2&&errors.has('email')">{{errors.first('email')}}</span>
                                        </div>
                                    </li>
                                    <li>
                                        <div class="input_wrap">
                                            <label class=" label required">最高学历</label>
                                            <div class="select-ul-wrap">
                                                <vue-select  :name="'eduLevel'" :readonly="step2" @closed="closedEduLevel" @selected="getEduLevel" :id="baseInfo.eduLevel" v-model="list.educationList[0].title" :selectKey="'title'" :selectList="list.educationList"></vue-select>
                                            </div>
                                        </div>
                                        <div class="err">
                                            <span v-show="!step2 && msg.eduLevelFlag">请选择最高学历</span>
                                        </div>
                                    </li>
                                    <li>
                                        <div class="input_wrap">
                                            <label class=" label required">毕业院校</label>
                                            <input type="text" name="college" :readonly="step2" maxlength="50"  v-model="baseInfo.college" v-validate="'required'" placeholder="">
                                        </div>
                                        <div class="err">
                                            <span v-show="!step2&&errors.has('college')">{{errors.first('college')}}</span>
                                        </div>
                                    </li>
                                    <li>
                                        <div class="input_wrap">
                                            <label class=" label required">主修专业</label>
                                            <input type="text" name="major" :readonly="step2" v-model="baseInfo.major" v-validate="'required'" maxlength="20" placeholder="">
                                        </div>
                                        <div class="err">
                                             <span v-show="!step2 && errors.has('major')">{{errors.first('major')}}</span>
                                        </div>
                                    </li>
                                    <li>
                                        <div class="input_wrap">
                                            <label class=" label required">履历背景</label>
                                            <div class="select-ul-wrap">
                                                <vue-select  :name="'background'" :id="baseInfo.background" :readonly="step2" @closed="closedBackground" @selected="getBackground" v-model="list.backgroundList[0].title" :selectKey="'title'" :selectList="list.backgroundList"></vue-select>
                                            </div>
                                        </div>
                                        <div class="err">
                                            <span v-show="!step2 && msg.backgroundFlag">请选择履历背景</span>
                                        </div>
                                    </li>
                                    <li>
                                        <div class="input_wrap ">
                                            <label class=" label required">从业起始年份</label>
                                            <div class="date-wrap" >
                                                <date-picker class="date-time" language="zh" :disabled-picker="step2" @closed="closedStartYear" :initial-view="'year'" :yearViewOnly="true" :format="'yyyy'" name="startYear" v-model="msg.startYear1"  :input-class="'input'"></date-picker>
                                            </div>
                                            <!--<input v-else type="text" v-model="msg.startYear" :readonly="netType==2"  name="startYear" placeholder="">-->
                                            <!--<input type="text" name="startYear" :readonly="step2" v-validate="'required|number'" v-model="baseInfo.startYear" placeholder="">-->
                                        </div>
                                        <div class="err">
                                            <!--<span v-show="!step2&&errors.has('startYear')">{{errors.first('startYear')}}</span>-->
                                            <span v-show="!step2 && msg.startYearFlag">请选择从业起始年份</span>
                                        </div>
                                    </li>
                                </ul>
                            </div>
                        </div>
                        <!--更多说明-->
                        <div class="item">
                            <div class="title"><div class="sub-title">更多说明</div></div>
                            <div class="baseinfo-wrap">
                                <!--管理规模-->
                                <div class="input-item">
                                    <div class="item-main">
                                        <label class="label required">个人简介</label>
                                        <div class="textarea-wrapper">
                                            <vue-textarea :num="500"  ref="resume" @errorsChanged="errorsResume" :readonly="step2" :validate="'required'"  :html="true" :name="'resume'" v-model="baseInfo.resume" :placeholder="'(必填)，简要说明个人简介'"></vue-textarea>
                                        </div>
                                    </div>
                                </div>
                                <!--投资理念-->
                                <div class="input-item">
                                    <div class="item-main">
                                        <label class="label required">投资风格</label>
                                        <div class="textarea-wrapper">
                                            <vue-textarea  ref="investmentStyle" @errorsChanged="errorsStyle" :num="500" :validate="'required'" :readonly="step2" :name="'investmentStyle'" v-model="baseInfo.investmentStyle" :placeholder="'(必填)，简要说明投资风格'"></vue-textarea>
                                        </div>
                                    </div>
                                </div>
                                <ul class="clearfix">
                                    <li>
                                        <div class="input_wrap ">
                                            <label class=" label">职位类别</label>
                                            <div class="select-ul-wrap">
                                                <vue-select :readonly="step2" :id="baseInfo.personnelType" :name="'personnelType'"  @selected="getPersonnelType" v-model="list.personnelTypeList[0].title" :selectKey="'title'" :selectList="list.personnelTypeList"></vue-select>
                                            </div>
                                        </div>
                                        <div class="err">
                                            <span></span>
                                        </div>
                                    </li>
                                    <li>
                                        <div class="input_wrap ">
                                            <label class=" label required">职位</label>
                                            <input type="text" :readonly="step2"  name="position" v-validate="'required'" v-model="baseInfo.position" maxlength="20"  placeholder="请输入职位">
                                        </div>
                                        <div class="err">
                                            <span v-show="errors.has('position')">{{errors.first('position')}}</span>
                                        </div>
                                    </li>
                                </ul>
                                <!--核心人物-->
                                <div class="input-item">
                                    <!--公司logo-->
                                    <div class="input-item company-logo">
                                        <div class="item-main clearfix">
                                            <label class="label">个人照片</label>
                                            <div class="logo_wrap">
                                                <div class="img_wrap">
                                                    <img v-show="!baseInfo.photoPath || baseInfo.photoPath==null" src="../../assets/img/common/zwt.png" width="100" height="100">
                                                    <img v-show="baseInfo.photoPath && baseInfo.photoPath!=null" :src="baseInfo.photoPath" width="100" height="100">
                                                </div>
                                                <div class="up-load"  v-show="!step2">
                                                    <div class="load-wrap">
                                                        <up-load :postURL="postUrl" :postType="postType" @showSmallImg="getPhotoPath" :labelText="'选择文件'" :color="'$btn-408'"></up-load>
                                                    </div>
                                                    <!--<label class="file-label" for="type-upload">选择文件</label>-->
                                                    <!--<input type="file" id="type-upload">-->
                                                    <!--<fileupload id="type-upload" target="http://localhost:8081/static/upload" action="POST"  ></fileupload>-->
                                                    <span>支持480*480图片大小，格式支持jpeg、jpg、png</span>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <!--提交按钮-->
                        <div class="btn-commit-wrap" v-show="!step2">
                            <button class="btn-bg-def commit btn" type="submit">提交</button>
                            <button class="btn-def save  btn" @click="gotoSave">保存暂不提交</button>
                        </div>
                        <p class="ps-hot">温馨提示：审核期间不可编辑基金信息</p>
                    </form>
                </div>
            </div>
        </div>
        <submit-ok :isSave="isSave" @closeModal="golist"></submit-ok>
    </div>
</template>
<script>
//    import datePicker from 'vuejs-datepicker';
import datePicker from '../../components/middleware/Datepicker';
    import vueSelect from '../../components/form/select'
    import vueTextarea from '../../components/form/textarea'
    import formList from '../../assets/js/formList'
    import upLoad from '../../components/common/upload';
    import tool from '../../assets/js/common/tool';
    import submitOk from '../../components/modal/submitOk';
    export default {
         components:{
             datePicker,
             vueSelect,
             upLoad,
             vueTextarea,
             submitOk
        },
        data (){
            return {
                isSave: false,
                step1: false,
                step2: true,
                step3: false,
                list: formList,
                suggestionAttribute: 'title',
                suggestions: [],
                postUrl: '/fileupload/uploadimg',
                postType: 'Manager_photo',
              managerType: '',
                baseInfo:{
                    keyFigure: 1 ,//核心人物  默认是
                    ifinclude:1, //核心团队  默认是
                    major: null,
                    email: null,
                    resume: null,
                    name: null,
                    phone: null,
                    gender: formList.sexList[0].id,
                    birthYear1: null,
                    eduLevel: formList.educationList[0].id,
                    college: null,
                    background: formList.backgroundList[0].id,
                    startYear: null,
                    investmentStyle: null,
                    position: null,
                    photoPath: null,
                    personnelType: formList.personnelTypeList[0].id,
                },
                msg:{
                    gender: formList.sexList[0].title,
                    birthYear2: '',
                    startYear1: '',
                    startYear2: null,
                    resumeFlag: false,
                    styleFlag: false,
                    startYearFlag: false,
                    genderFlag: false, /*性别*/
                    eduLevelFlag: false, /*最高学历*/
                    backgroundFlag: false, /*履历背景*/

//                    keyFigure1Flag: true
                }
            }
        },
        mounted(){
            this.geDetail();
        },
        watch: {
            $route(){
                this.geDetail();
            }
        },
        computed:{
            allTextFlag(){
                return this.msg.resumeFlag && this.msg.styleFlag
            },
            allSeleFlag(){
              return !this.msg.genderFlag && !this.msg.eduLevelFlag && !this.msg.backgroundFlag
            }
        },
        created(){
            this.$store.commit('getLoginInfo');
        },
        methods:{
            /*单独验证问题*/
            errorsStyle(flag){
                this.msg.styleFlag = flag;
            },
            errorsResume(flag){
                this.msg.resumeFlag = flag;
            },


            /*获取详情*/
            geDetail(){
                this.managerId = this.$route.params.id;
                this.managerType = parseInt(this.$route.params.type);
                if(this.managerType == 1){
                    this.setStep(3);
                } else if(this.managerType == 2){
                    this.setStep(1);
                } else {
                    this.setStep(1);
                }
                if(this.managerType > 0){
                    this.getManagerDetail();
                }
            },
            setStep(id){
                this.step2 = false;
                this.step1 = false;
                this.step3 = false;
                this['step'+ id] = true;
            },
            getManagerDetail(){
                let url = this.managerType == 1 ? `/manager/result/fundDcId_${this.managerId}/detail` : `/manager/report/id_${this.managerId}/detail`;
                this.$http.request({
                    url: url
                }, res => {
                    if(res.data.code === 200){
                        this.baseInfo = res.data.data;
                        if(this.managerType ==2 && this.baseInfo.auditStatus == 0){  //待审核
                            this.setStep(2);
                        }
                        this.initTimeData();
                    }
                }, err => {

                });
            },
            /*初始化某些字段*/
            initTimeData(){
                this.msg.startYear1 = tool.numToDate(this.baseInfo.startYear);
//                console.log(this.msg.startYear1)
                this.baseInfo.birthYear1 = tool.numToDate(this.baseInfo.birthYear);
                this.msg.birthYear2 = tool.transformTime(this.baseInfo.birthYear, 'yyyy-mm-dd');

            },
            beforeCommit(){
                if(this.managerType === 1){
                    this.$delete( this.baseInfo, 'id');
                }
                this.baseInfo.birthYear = tool.dateToNum(this.baseInfo.birthYear1);
                this.baseInfo.startYear =  tool.dateToNum(this.msg.startYear1);
            },
            golist(){
                this.$router.push({path: '/manager', query:{item: 2}});
            },
            getFlag(){
              this.closedStartYear();
              this.closedGender(); /*性别*/
              this.closedEduLevel(); /*最高学历*/
              this.closedBackground(); /*履历背景*/
            },
            /*获取个人照片*/
            getPhotoPath(url){
                this.baseInfo.photoPath = url;
            },
            closedStartYear(){
              if(!!this.msg.startYear1 &&  this.msg.startYear1 !=null){
                this.msg.startYearFlag = false;
              } else {
                this.msg.startYearFlag = true;
              }
            },
            /*性别*/
            getGender(obj){
                this.baseInfo.gender = obj.id;
            },
            closedGender(){
              if(typeof this.baseInfo.gender != 'number'){
                this.msg.genderFlag = true;
              } else {
                this.msg.genderFlag = false;
              }
            },
            /*最高学历*/
            getEduLevel(obj){
                this.baseInfo.eduLevel = obj.id;
            },
            closedEduLevel(){
              if(this.baseInfo.eduLevel == null || this.baseInfo.eduLevel == undefined){
                this.msg.eduLevelFlag = true;
              } else {
                this.msg.eduLevelFlag = false;
              }
            },
            /*getBackground*/
            getBackground(obj){
                this.baseInfo.background = obj.id;
            },
            closedBackground(){
               if(this.baseInfo.background == null || this.baseInfo.background == undefined){
                 this.msg.backgroundFlag = true;
               } else {
                 this.msg.backgroundFlag = false;
               }
            },
            /*职位类别*/
            getPersonnelType(obj){
                this.baseInfo.personnelType = obj.id;
            },
            changed(){
                this.suggestions = [];
            },
            showModal(){
                this.$modal.show('submitOk');
//                this.$router.push('/manager');
            },
            /*提交信息*/
            goSubmit(){
                this.getFlag();
                this.$refs.investmentStyle.validateChild();
                this.$refs.resume.validateChild();
                this.$validator.validateAll().then( result => {
                    if(result && this.allTextFlag && this.allSeleFlag &&  !this.msg.startYearFlag){
                        this.beforeCommit();
                        this.$http.request({
                            url: `/manager/saveOrUpdateThenAudit`,
                            method: 'post',
                            data: this.baseInfo
                        }, res =>{
                            if(res.data.code == 200){
                                this.isSave = false;
                                this.showModal();
                            }
                        }, err => {

                        });
                    }
                });

            },
            gotoSave(e){
                e.preventDefault();
                this.beforeCommit();
                this.$http.request({
                    url: `/manager/saveOrUpdate`,
                    method: 'post',
                    data: this.baseInfo
                }, res =>{
                    if(res.data.code == 200){
                        this.isSave = true;
                        this.showModal();
                    }
                }, err => {

                });
            }
        }
    }
</script>
<style lang="scss" type="text/scss" scoped>
    @import "../../assets/css/common/form";
    .message_content{
        @include bgff;
        padding: 50px 40px 55px;
        .load-wrap{
            display: inline-block;
            /*vertical-align: ;*/
        }
        .main-people{
            margin-bottom:30px;
            .span-tip, .radio_wrap{
                display: inline-block;
                vertical-align: middle;
                font-size:16px;
            }
            .span-tip{
                width: 120px;
                text-align: right;
                color: #666;
                margin-right: 3px;
            }
            .radio_wrap{
                .radio-item{
                    float:left;
                    margin-right:30px;
                    .radio{
                        border: 1px solid $border_bfb;
                        width:18px;
                        height:18px;
                        border-radius: 50%;
                        padding-top:3px;
                        padding-left:3px;
                        display: inline-block;
                        vertical-align: middle;
                        &.active{
                            border-color:$btn_408;
                            .rad{
                                width:10px;
                                height:10px;
                                background: $btn_408;
                                border-radius: 50%;
                            }
                        }
                    }
                    .text{
                        display: inline-block;
                        vertical-align: middle;
                    }
                }

            }
        }
    }
</style>



// WEBPACK FOOTER //
// src/views/manager/detail.vue